import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined,LogoutOutlined } from '@ant-design/icons';
import { FaTachometerAlt, FaPhoneAlt, FaHeadset, FaRegUserCircle } from 'react-icons/fa';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import logo from '../assets/img/logo.png';
import logodev from '../assets/logodev.png';
 

const { Header, Sider, Content } = Layout;

const MenuLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  const [selectedKey, setSelectedKey] = useState(['1']);
  const [perfil, setPerfil] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  // Carrega o perfil do localStorage ao montar o componente
  useEffect(() => {
    const perfilSalvo = localStorage.getItem("perfil");
    setPerfil(perfilSalvo);
  }, []);






  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("loginTime");
    localStorage.removeItem("perfil");
    window.location.href = "/";
  };


  useEffect(() => {
    const loginTime = parseInt(localStorage.getItem("loginTime"), 10) || Date.now();
    localStorage.setItem("loginTime", loginTime);

    const now = Date.now();
    const expired = now - loginTime > 3600000; 
 
    if (expired) {
      logout();
      return;
    }

    const remainingTime = 3600000 - (now - loginTime);
    const timeout = setTimeout(logout, remainingTime);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
   

    const interval = setInterval(() => {
     
    }, 6000);  

    return () => clearInterval(interval);
  }, []);







  // Controla seleção e abertura de menus conforme rota
  useEffect(() => {
    if (location.pathname.includes('/dashboard') || location.pathname === '/') {
      setSelectedKey(['1']);
      setOpenKeys([]);
    } else if (location.pathname === '/agentes') {
      setOpenKeys(['3']);
      setSelectedKey(['3']);
    } else if (location.pathname === '/usuarios') {
      setOpenKeys(['4']);
      setSelectedKey(['4']);
    } else if (
      location.pathname.includes('/chamadas') ||
      location.pathname.includes('/registadas') || 
       location.pathname.includes('/whatsapp') 
    ) {
      setOpenKeys(['2']);

      if (location.pathname === '/chamadas') {
        setSelectedKey(['2-1']);
      } else if (location.pathname === '/registadas') {
        setSelectedKey(['2-2']);
      }
      else if (location.pathname === '/whatsapp') {
        setSelectedKey(['2-3']);
      }
    } else {
      setSelectedKey([]);
      setOpenKeys([]);
    }
  }, [location.pathname]);

  // Define todos os menus disponíveis
  const allMenuItems = [
    {
      key: '1',
      icon: <FaTachometerAlt />,
      label: 'Dashboard',
      onClick: () => {
        setOpenKeys([]);
        navigate('/dashboard');
      },
    },
    {
      key: '2',
      icon: <FaPhoneAlt />,
      label: 'Chamadas',
      children: [
        {
          key: '2-1',
          label: 'Todas',
          onClick: () => navigate('/chamadas'),
        },
        {
          key: '2-2',
          label: 'Registadas',
          onClick: () => navigate('/registadas'),
        },
                {
          key: '2-3',
          label: 'WhatsApp',
          onClick: () => navigate('/whatsapp'),
        },
      ],
    },
    {
      key: '3',
      icon: <FaHeadset />,
      label: 'Agentes',
      onClick: () => {
        setOpenKeys([]);
        navigate('/agentes');
      },
    },
    {
      key: '4',
      icon: <FaRegUserCircle />,
      label: 'Usuários',
      onClick: () => {
        setOpenKeys([]);
        navigate('/usuarios');
      },
    },
    {
      key: '5',
      icon: <LogoutOutlined />,
      label: 'Sair',
      onClick: logout
    },
  ];

  // Aplica filtro conforme perfil
  const filteredMenuItems =
    perfil === 'ADMIN'
      ? allMenuItems // Admin vê tudo
      : perfil === 'USER'
      ? allMenuItems.filter(item => item.key !== '3') // USER não vê "Agentes"
      : []; // caso não tenha perfil ainda carregado

  const logoOffsetY = 50;
  const menuOffsetY = 15;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={250}
        style={{
          background: '#000',
          position: 'fixed',
          height: '100vh',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 100,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Logo */}
        <div
          style={{
            height: 64,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: 20,
            fontWeight: 'bold',
            marginTop: logoOffsetY,
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{ height: 36, marginRight: collapsed ? 0 : 8 }}
          />
          {!collapsed}
        </div>

        {/* Menu */}
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={selectedKey}
          openKeys={openKeys}
          onOpenChange={keys => setOpenKeys(keys)}
          items={filteredMenuItems}
          style={{
            background: 'transparent',
            borderRight: 'none',
            marginTop: menuOffsetY,
            width: '90%',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
          className="custom-menu"
        />
      </Sider>

      {/* Área principal */}
      <Layout
        style={{
          marginLeft: collapsed ? 80 : 250,
          transition: 'all 0.3s',
          background: '#f5f5f5',
        }}
      >
        <Header
          style={{
            background: '#ffffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 20px',
            boxShadow: '0 1px 4px rgba(255, 255, 255, 0.1)',
            position: 'sticky',
            top: 0,
            zIndex: 10,
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ fontSize: 18, color: '#ffffffff' }}
          />

          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={logodev}
              alt="Logo Dev"
              style={{ height: 32, marginRight: 8 }}
            />
          </div>
        </Header>

        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            background: '#fff',
            borderRadius: 12,
            minHeight: 280,
            boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
          }}
        >
          <Outlet />
        </Content>
      </Layout>

      {/* CSS permanece igual */}
      <style jsx global>{`
        .custom-menu {
          width: 90% !important;
          margin-left: auto !important;
          margin-right: auto !important;
        }

        .custom-menu .ant-menu-item,
        .custom-menu .ant-menu-submenu-title {
          border-radius: 25px !important;
          margin: 8px 0px !important;
          height: 45px !important;
          display: flex !important;
          align-items: center !important;
          transition: all 0.3s ease !important;
          background: transparent !important;
          border: none !important;
          padding: 0 16px !important;
        }

        .custom-menu .ant-menu-item:not(.ant-menu-item-selected):hover,
        .custom-menu .ant-menu-submenu-title:hover {
          background: #ff0000 !important;
          color: white !important;
        }

        .custom-menu .ant-menu-item-selected {
          background: #ff0000 !important;
          color: white !important;
          border-radius: 25px !important;
        }

        .custom-menu .ant-menu-item-selected .ant-menu-item-icon,
        .custom-menu .ant-menu-item-selected .ant-menu-title-content {
          color: white !important;
        }

        .custom-menu .ant-menu-item .ant-menu-item-icon,
        .custom-menu .ant-menu-submenu-title .ant-menu-item-icon {
          color: rgba(255, 255, 255, 0.85) !important;
          font-size: 16px !important;
          min-width: 20px !important;
        }

        .custom-menu .ant-menu-item .ant-menu-title-content,
        .custom-menu .ant-menu-submenu-title .ant-menu-title-content {
          color: rgba(255, 255, 255, 0.85) !important;
          font-weight: 500 !important;
          margin-left: 12px !important;
        }

        .custom-menu .ant-menu-item::after {
          display: none !important;
        }

        .ant-layout-sider-collapsed .custom-menu {
          width: 80% !important;
        }

        .ant-layout-sider-collapsed .custom-menu .ant-menu-item,
        .ant-layout-sider-collapsed .custom-menu .ant-menu-submenu-title {
          padding: 0 8px !important;
          justify-content: center !important;
        }
      `}</style>



 



    </Layout>
  );
};

export default MenuLayout;
